var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C16 17.5147 18.0147 15.5 20.5 15.5H30.5C31.3284 15.5 32 16.1716 32 17V32C32 32.5523 31.5523 33 31 33H19.5C17.7368 33 16.2781 31.6961 16.0354 30H16V20ZM30.5 27.5H19.5C18.3954 27.5 17.5 28.3954 17.5 29.5C17.5 30.6046 18.3954 31.5 19.5 31.5H30.5V27.5ZM20.25 20C20.25 19.5858 20.5858 19.25 21 19.25H28C28.4142 19.25 28.75 19.5858 28.75 20C28.75 20.4142 28.4142 20.75 28 20.75H21C20.5858 20.75 20.25 20.4142 20.25 20ZM21 22.25C20.5858 22.25 20.25 22.5858 20.25 23C20.25 23.4142 20.5858 23.75 21 23.75H26C26.4142 23.75 26.75 23.4142 26.75 23C26.75 22.5858 26.4142 22.25 26 22.25H21Z",
    fill: "#3D87BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveContent);
export default __webpack_public_path__ + "static/media/active-content.f90763fefc613d35b69decc117e32066.svg";
export { ForwardRef as ReactComponent };